// eslint-disable-next-line
export const validationMixin = {
  methods: {
    rulesToString() {
      if (typeof this.rules === 'object') {
        return Object.keys(this.rules).join('|')
      }
      return this.rules
    },
    requiredClassByRules() {
      const requiredFieldClass = 'required-input'
      if (
        (typeof this.rules === 'object' && this.rules.required === true) ||
        (typeof this.rules !== 'object' && this.rules.includes('required'))
      ) {
        return requiredFieldClass
      }
      return ''
    },
  },
}
